import { Badge, type MantineSize } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface StatusBadgeProps {
  label: string;
  isFinal?: boolean;
  variant?: "state" | "type";
  size?: MantineSize;
}

export function StatusBadge({
  label,
  isFinal = false,
  variant = "state",
  size = "sm",
}: StatusBadgeProps) {
  const { t } = useTranslation();

  if (variant === "type") {
    return (
      <Badge
        variant="outline"
        color="gray"
        size={size}
        style={{ whiteSpace: "nowrap" }}
      >
        {label}
      </Badge>
    );
  }

  return (
    <Badge
      variant="light"
      color={isFinal ? "teal" : "blue"}
      size={size}
      style={{ whiteSpace: "nowrap" }}
      aria-label={
        isFinal ? `${label} — ${t("common.finalState", "final")}` : undefined
      }
    >
      {label}
    </Badge>
  );
}
